import React, { useState } from "react";
import Header from "../components/common-web/Header";
import ResizablePanel from "../components/common/ResizablePanel";
import { SidebarCloseIcon, SidebarOpenIcon } from "../Icons";
import FdViewerSidebar from "../components/fd-viewer/FdViewerSlideBar";
import FdViewerContent from "../components/fd-viewer/FdViewerContent";
import AnimatedPopup from "../components/common/AnimatedPopup";
import searchWhite from "../assets/icons/search-white.svg";
import SearchResult from "../components/fd-viewer/SearchResult";

export default function FdViewer() {
  const [isOpenSidebar, setIsOpenSidebar] = useState(true);
  const [isOpenSearchResult, setIsOpenSearchResult] = useState(false);

  return (
    <main className="bg-[#262d44] h-screen flex flex-col overflow-hidden">
      <Header>
        <h1 className="text-white text-[19px] font-medium montserrat-font ">
          4D
        </h1>
      </Header>

      <div className="flex-1 flex flex-col overflow-hidden ">
        <ResizablePanel
          direction="horizontal"
          initialSize={268} // Adjust width when collapsed
          minSize={180}
          maxSize={400}
          isShowSidebar={isOpenSidebar}
          panelContent={
            <div className="flex flex-col bg-[#F1F1F1] text-[#242424] h-full">
              {/* Header Section */}
              <div className="flex items-center justify-between py-[5px] px-2.5 bg-white">
                <h6 className="text-[#242424] text-[12px] font-bold ">
                  On / Off & Search
                </h6>
                <button
                  className="w-6 aspect-square flex items-center justify-center"
                  onClick={() => setIsOpenSidebar(!isOpenSidebar)}
                >
                  {isOpenSidebar ? <SidebarCloseIcon /> : <SidebarOpenIcon />}
                </button>
              </div>

              {/* Sidebar Content */}
              {isOpenSidebar ? (
                <div className="flex-1 flex flex-col justify-between overflow-hidden transition-all duration-300">
                  <div className="custom-scrollbar flex-1 overflow-y-auto ">
                    <FdViewerSidebar />
                  </div>

                  {/* Footer */}
                </div>
              ) : null}
            </div>
          }
        >
          {/* Main Content */}
          <div className="flex flex-col h-full">
            <FdViewerContent setIsOpenSearchResult={setIsOpenSearchResult} />
          </div>
        </ResizablePanel>
      </div>

      {/* search Result popup  */}
      <AnimatedPopup
        label="검색 결과"
        isOpen={isOpenSearchResult}
        onClose={() => setIsOpenSearchResult(false)}
        className="max-w-[1320px]"
        icon={searchWhite}
      >
        <SearchResult />
      </AnimatedPopup>
    </main>
  );
}
